export enum Currency {
    USD = "$",
}

export const formatMoney = (currency: Currency, amount: number) => {
    return `${currency}${amount
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
};
